import { motion } from "framer-motion";
import { Store, ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../data/products";

const ProductCard = ({ product, index }) => (
  <motion.div
    data-testid={`product-card-${product.id}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
    className="group relative overflow-hidden rounded-2xl bg-[#121214] border border-white/5 shadow-[0_8px_24px_rgba(0,0,0,0.35)] transition-all duration-300 hover:border-[#00e5ff]/50 hover:shadow-[0_0_36px_rgba(0,229,255,0.16)] hover:-translate-y-1.5"
  >
    <div className="relative aspect-square overflow-hidden bg-[#0e0e10]">
      <img
        src={product.image}
        alt={`${product.name} available at FILL N' CHILL smoke shop in Maple Shade NJ`}
        loading="lazy"
        decoding="async"
        className={`w-full h-full transition-transform duration-700 group-hover:scale-110 ${
          product.fit === "contain"
            ? "object-contain p-5"
            : "object-cover"
        }`}
      />
      {product.tag && (
        <span className="absolute top-4 left-4 z-10 text-[11px] uppercase tracking-wider px-3 py-1 rounded-full glass text-[#39ff14]">
          {product.tag}
        </span>
      )}
      {product.fit !== "contain" && (
        <div className="absolute inset-0 bg-gradient-to-t from-[#121214] via-transparent to-transparent opacity-80" />
      )}
    </div>

    <div className="p-6">
      <h3 className="font-heading text-xl font-medium text-white">
        {product.name}
      </h3>
      <p className="mt-2 text-sm text-zinc-400 leading-relaxed min-h-[40px]">
        {product.description}
      </p>
      <div className="mt-5 flex flex-wrap items-center gap-3">
        <div className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full bg-[#39ff14]/10 text-[#39ff14] border border-[#39ff14]/20">
          <Store size={13} /> Available In Store
        </div>
        {product.viewDetails && (
          <button
            data-testid={`product-view-details-${product.id}`}
            onClick={() =>
              document
                .getElementById("visit")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="inline-flex items-center gap-1.5 text-xs font-medium px-4 py-1.5 rounded-full border border-[#00e5ff]/40 text-[#00e5ff] hover:bg-[#00e5ff]/10 transition-all duration-300"
          >
            View Details <ArrowUpRight size={13} />
          </button>
        )}
      </div>
    </div>
  </motion.div>
);

export const Products = () => {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0b]"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="text-sm uppercase tracking-[0.25em] text-zinc-500">
            Our Catalog
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight mt-4">
            Everyday Convenience &amp;{" "}
            <span className="text-gradient">Premium Vape &amp; Smoke</span>
          </h2>
          <p className="mt-5 text-zinc-400">
            From snacks, cold drinks, candy, and convenience essentials to
            disposable vapes, nicotine pouches, kratom, and smoking accessories—
            here&apos;s a look at what we carry. Stop by our Route 38 location in
            Maple Shade to see the full selection in-store.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
